module.exports = __webpack_public_path__ + "images/emoji/balloon.0a44542a128e9ccd8718.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/balloon.png
// module id = FlNx
// module chunks = 14